import moment from 'moment';
import React from 'react';
import styled from 'styled-components';

const DatePillContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  border-radius: 8px;
  overflow: hidden;
`;

const DateDay = styled.span`
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.1)'
      : 'rgba(0, 0, 0, 0.05)'};
  padding: 10px 14px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.2)'
        : 'rgba(0, 0, 0, 0.1)'};
  border-radius: 8px 0 0 8px;
  color: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors?.text?.primary || '#ffffff'
      : '#000033'};
`;

const DateNum = styled.span`
  background: ${(props) => props.theme.colors?.primary || '#FA4616'};
  padding: 10px 14px;
  font-size: 12px;
  font-weight: 700;
  border-radius: 0 8px 8px 0;
  color: #ffffff;
`;

/**
 * POSDatePill - A date display component for POS interfaces
 * Supports single dates and date ranges
 *
 * @param {Object} props
 * @param {string} props.startDate - Start date in MM-DD-YYYY format
 * @param {string} props.endDate - Optional end date in MM-DD-YYYY format (for multi-day events)
 * @param {boolean} props.isMultiDay - Whether the event spans multiple days
 */
const POSDatePill = ({ startDate, endDate, isMultiDay }) => {
  if (!startDate) return null;

  const start = moment(startDate, 'MM-DD-YYYY');
  const end = endDate ? moment(endDate, 'MM-DD-YYYY') : null;

  // Format day of week
  const dayOfWeek = start.format('ddd').toUpperCase();

  // Format date display
  let dateDisplay;
  if (isMultiDay && end && end.isValid()) {
    // Check if same month
    if (start.month() === end.month()) {
      // Same month: "FEB 14-16"
      dateDisplay = `${start.format('MMM').toUpperCase()} ${start.format(
        'D'
      )}-${end.format('D')}`;
    } else {
      // Different months: "FEB 28-MAR 2"
      dateDisplay = `${start.format('MMM D').toUpperCase()}-${end
        .format('MMM D')
        .toUpperCase()}`;
    }
  } else {
    // Single day: "FEB 14"
    dateDisplay = start.format('MMM D').toUpperCase();
  }

  return (
    <DatePillContainer>
      <DateDay>{dayOfWeek}</DateDay>
      <DateNum>{dateDisplay}</DateNum>
    </DatePillContainer>
  );
};

export default POSDatePill;
